import { styled } from '@mui/material/styles';

export const StyledLink = styled('a')`
    text-decoration: none;
`;
